import { buildProps, isNumber } from '@xzx-design/utils'
import { CHANGE_EVENT } from '@xzx-design/constants'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Steps from './steps.vue'

export const stepsProps = buildProps({
  active: {
    type: Number,
    default: 0,
  },
  direction: {
    type: String,
    values: ['horizontal', 'vertical'],
    default: 'horizontal',
  },
  simple: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
  },
  /**
   * @description 当前步骤状态
   */
  processStatus: {
    type: String,
    values: ['wait', 'process', 'finish', 'error'],
    default: 'process',
  },
})

export const stepsEmits = {
  [CHANGE_EVENT]: (newVal: number, oldVal: number) =>
    [newVal, oldVal].every(isNumber),
}

export type StepsProps = ExtractPropTypes<typeof stepsProps>
export type StepsInstance = InstanceType<typeof Steps>
